import { render, staticRenderFns } from "./realauth.vue?vue&type=template&id=64e1fd36&"
import script from "./realauth.vue?vue&type=script&lang=js&"
export * from "./realauth.vue?vue&type=script&lang=js&"
import style0 from "./realauth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports